(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.init(root);
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function isCartAddRequest(input) {
    const value = typeof input === 'string' ? input : input && input.url;
    if (!value) return false;
    try {
      return /\/cart\/add(?:\.js)?(?:\?|$)/.test(new URL(value, 'https://shop.local').pathname + new URL(value, 'https://shop.local').search);
    } catch (_) {
      return false;
    }
  }

  function lineToItem(line) {
    const priceInCents = Number(line.final_price ?? line.price ?? 0);
    return {
      item_id: String(line.product_id ?? line.id ?? ''),
      item_variant: String(line.variant_id ?? line.id ?? ''),
      item_name: String(line.product_title ?? line.title ?? ''),
      item_variant_name: String(line.variant_title ?? ''),
      price: priceInCents / 100,
      quantity: Number(line.quantity) || 1,
    };
  }

  function buildItems(payload) {
    if (!payload) return [];
    const lines = Array.isArray(payload.items) ? payload.items : [payload];
    return lines.filter(line => line && (line.id || line.product_id)).map(lineToItem);
  }

  function send(root, name, params) {
    if (typeof root.gtag === 'function') root.gtag('event', name, params || {});
  }

  function whatsappButtonName(link) {
    if (!link) return '';
    if (link.dataset && link.dataset.waButton) return link.dataset.waButton;
    const section = link.closest && link.closest('[id^="shopify-section-"]');
    return section ? section.id.replace('shopify-section-', '') : 'sin-nombre';
  }

  function isWhatsAppLink(href) {
    return /(?:wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)/i.test(String(href || ''));
  }

  function init(root) {
    if (root.__ddcGa4Initialized) return;
    root.__ddcGa4Initialized = true;

    root.document.addEventListener('click', event => {
      const link = event.target.closest && event.target.closest('a[href]');
      if (!link || !isWhatsAppLink(link.href)) return;
      send(root, 'whatsapp_click', {
        button_name: whatsappButtonName(link),
        page_type: (root.document.body && root.document.body.dataset.template) || root.location.pathname,
        transport_type: 'beacon',
      });
    }, true);

    const originalFetch = root.fetch && root.fetch.bind(root);
    let checkoutInFlight = false;
    if (originalFetch) {
      root.fetch = async function (input, initOptions) {
        const response = await originalFetch(input, initOptions);
        if (response.ok && isCartAddRequest(input)) {
          response.clone().json().then(payload => {
            const items = buildItems(payload);
            if (!items.length) return;
            const value = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
            send(root, 'add_to_cart', { currency: 'COP', value, items });
          }).catch(() => {});
        }
        return response;
      };
    }

    root.document.addEventListener('click', event => {
      const target = event.target.closest && event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
      if (!target || checkoutInFlight || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      checkoutInFlight = true;
      event.preventDefault();
      const destination = target.href || '/checkout';
      const navigate = () => root.location.assign(destination);
      const fallback = root.setTimeout(navigate, 800);

      originalFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(response => response.ok ? response.json() : Promise.reject(new Error('Cart unavailable')))
        .then(cart => {
          const items = buildItems(cart);
          send(root, 'begin_checkout', {
            currency: cart.currency || 'COP',
            value: Number(cart.total_price || 0) / 100,
            items,
            transport_type: 'beacon',
            event_callback: () => {
              root.clearTimeout(fallback);
              navigate();
            },
          });
        })
        .catch(() => {
          root.clearTimeout(fallback);
          navigate();
        });
    }, true);
  }

  return { isCartAddRequest, buildItems, isWhatsAppLink, init };
});
